<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/11V6B8C/tc-custom/9781607107040.jpg?1738759480571" alt="This image is the cover for the book Uncle John's Fully Loaded: 25th Anniversary Bathroom Reader, Uncle John's Bathroom Reader Annual"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Uncle John's Fully Loaded: 25th Anniversary Bathroom Reader, Uncle John's Bathroom Reader Annual
      </h1>
      <p class="bookDescription body article font2">
        <b>Take a seat and settle in—it’s a gigantic treasury of trivia and humor for our twenty-fifth (is that porcelain?) anniversary!</b><br/>  <br/><i>IBPA Benjamin Franklin Award Gold Winner in Humor </i><br/><i>ForeWord Reviews Book of the Year Awards, Honorable Mention in Humor </i><br/>  <br/> “Fully Loaded” is putting it mildly. This behemoth of a book is overflowing with incredible stories, surprising facts, weird news, little-known origins, forgotten history, fun wordplay, and everything else that millions of loyal fans have come to expect from the world’s best-selling bathroom reading series.<br/>  <br/> As always, it’s divided by length: quickies for the reader on the go, medium-sized articles for those with a few minutes to spare, and extra-long pieces for those truly leg-numbing experiences. Here are just a few of the hundreds of topics loaded into this edition of America’s favorite source of fascinating information:<br/>  <br/> * Forgotten Firsts * Dumb Crooks: Stoner Edition * Bizarre Japanese Video Games * The Kamikaze Instruction Manual * Our Lady of the Little Green Men * The Worst Fire in American History * The World’s Worst Business Decision * The New Year’s Eve Opossum Drop * Do Blondes Really Have More Fun? * Failed Doomsday Predictions * When Toilets Explode * and much, much more! 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Bathroom Readers' Institute
      </h2>
      
      <p class="authorDescription body article">The Bathroom Readers' Institute is a tight-knit group of loyal and skilled writers, researchers, and editors who have been working as a team for years. The BRI understands the habits of a very special market—Throne Sitters—and devotes itself to providing amazing facts and conversation pieces.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bathroom Readers’ Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d41bdd92